import React from 'react';

import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';

import { useIsHaugesund } from '@hooks/use-bank-type';
import useText from '@hooks/use-text';

import './ViewComplaint.scss';

const ViewComplaint = (): JSX.Element => {
    const { complaintTitle, complaintDescription, complaintNote, complaintLink } = useText();
    const haugesund = useIsHaugesund();

    if (haugesund) {
        window.history.back();
    }

    return (
        <section aria-labelledby="complaint-title" className="view-complaint-wrapper">
            <h1 id="complaint-title">{complaintTitle}</h1>
            <p>{complaintDescription}</p>
            <p>{complaintNote}</p>

            <div className="paragraph complaint-link -space-top">
                <Link
                    href="https://mydispute.nets.eu/?region=no"
                    target="_blank"
                    iconOnRightSide
                    icon={IconTypes.EKSTERN_24}
                >
                    {complaintLink}
                </Link>
            </div>
        </section>
    );
};

export default ViewComplaint;
